import { jsx } from 'react/jsx-runtime';
import { useRef, useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import MuiTableBody from '@mui/material/TableBody';
import 'date-fns/format';
import event from '../../utils/events.js';
import { gridHorizontalScrollEvent } from './scrollUtils.js';

const _MuiTableBody = styled(MuiTableBody, {
    shouldForwardProp: prop => !['panelWidth', 'width', 'rtl', 'columnResizingShift'].includes(prop),
}) `
  ${({ panelWidth, width, rtl }) => `
    flex: 1;
    overflow: auto;
    position: relative;
    
    & ::-webkit-scrollbar:horizontal { 
      display: none;
    }

    > div {
      width: ${width - (panelWidth || 0)}px !important;
      overflow-x: auto !important;
      direction: ${rtl ? 'rtl' : 'ltr'} !important;
      transform: translateX(${rtl ? panelWidth : 0}px);
    }
  `}
`;
const scrollHandler = (e) => {
    var _a;
    event.emit(gridHorizontalScrollEvent, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.scrollLeft, 'body');
};
const TableBody = (props) => {
    const scrollerRef = useRef();
    const [scrollLeft, setScrollLeft] = useState(0);
    useEffect(() => {
        event.on('TableBody', gridHorizontalScrollEvent, (scrollLeft, origin) => {
            if (origin === 'body')
                return;
            return setScrollLeft(scrollLeft);
        });
        return () => event.off('TableBody', gridHorizontalScrollEvent);
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d;
        if ((_b = (_a = scrollerRef.current) === null || _a === void 0 ? void 0 : _a.lastChild) === null || _b === void 0 ? void 0 : _b.scrollTo) {
            (_d = (_c = scrollerRef.current) === null || _c === void 0 ? void 0 : _c.lastChild) === null || _d === void 0 ? void 0 : _d.scrollTo({ left: scrollLeft });
        }
    }, [scrollLeft]);
    return (jsx(_MuiTableBody
    // @ts-ignore
    , Object.assign({ 
        // @ts-ignore
        component: "div", onScrollCapture: scrollHandler, ref: scrollerRef }, props)));
};
TableBody.displayName = 'TableBody';

export { TableBody as default };
//# sourceMappingURL=TableBody.js.map
